export default {
    authTokenBM: 'oauth/token',
    property: '/api/property',
    request_signature: '/api/esignature/lease',
    property_agent_sign: '/api/esignature/lease/execute/{id}',
};
